import React, { useEffect, useReducer, useRef, useState } from 'react';
import { ClosedCaptionManager } from '../cvp-webgames-core/ClosedCaptionManager';
import ReactCaption from '../cvp-webgames-core/Components/general/react/ReactCaption';
import { SingleUI } from '../cvp-webgames-core/Components/ui/react/base/SingleUI';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import { constants } from '../misc/constants';
import useFade from '../misc/use-fade';
import WelcomePage from '../pages/Welcome';
import IntroScreenUI, { IntroScreenUIConfig } from './ui/intro-screen-ui';
import SavingUI from './ui/saving-ui';
import CoreReturnToMainMenuUI from '../cvp-webgames-core/Components/ui/react/core-return-to-main-menu-ui';
import QuestionType1UI from './ui/question-type1-ui';
import FeedbackUI from './ui/feedback-ui';
import AlertUI from './ui/alert-ui';
import SkipContentUI from './ui/skip-content-ui';
import ScenarioInfoUI from './ui/scenario-info-ui';
import HUDUI from './hud/HUDUI';
import OverlayImg from './ui/overlay-img';
import AiChatUI from './ui/ai-chat';
import { CustomGameDataManager, parseDynamicHtml } from '../misc/tools';
import Tools from '../cvp-webgames-core/Misc/Tools';
import MentorUI from './ui/mentor-ui';

const reducer = (state: any, action: any) => {
	return state;
};

let ccManager: ClosedCaptionManager = null;
let savedData: CustomGameDataManager = null;
Tools.getSaveData().then((retrievedData: CustomGameDataManager) => {
	savedData = retrievedData;
	if((window as any)['cc-inited']) {
		(window as any)['cc-inited']();
	}
})
const UIOverlay = (props: any) => {
	const [uisRegistered, setUisRegistered] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	const { fadeClass, fadeStyle, onFadeIn, onFadeOut } = useFade({ transitionDuration: '250ms', delay: 250, disableFadeInOnMount: true, disableAutoFadeout: true });

	const [state, dispatch] = useReducer(reducer, {
		uiProps: null,
		gameManager: props.gameManager
	});

	let isDisplayingHeader = false;

	(window as any).setCCManager = (ccM: any) => {
		ccManager = ccM;
		(window as any).forceUpdateInternalCCComp();
		// if((window as any).onCaptionsChanged) {
		//     (window as any).onCaptionsChanged();
		// }
	}


	useEffect(() => {
		$(window).resize();

		if (uisRegistered) {
			return;
		}

		(window as any)['forceEntireUIRefresh'] = () => {
			setForceUpdate(!forceUpdate);
		}

		setUisRegistered(true);

		let uiManager = props.gameManager.UiManager as JsxUIManager;

		uiManager.registerGeneralUIs();

		uiManager.registerUI(constants.uiNames.ReturnToMainMenuUI, {
			renderMethod: (instance) => {
				return <CoreReturnToMainMenuUI id={instance.id} key={instance.id} parameters={instance.parameters}></CoreReturnToMainMenuUI>
			}
		});

		uiManager.registerUI(constants.uiNames.HUDUI, {
			renderMethod: (instance: any) => {
				return <HUDUI id={instance.id} dispatch={dispatch} key={instance.id} parameters={instance.parameters}></HUDUI>
			}
		}, constants.uiTags.Hud);

		uiManager.registerUI(constants.uiNames.QuestionType1UI, {
			renderMethod: (instance) => {
				return <QuestionType1UI id={instance.id} key={instance.id} parameters={instance.parameters}></QuestionType1UI>
			}
		});

		uiManager.registerUI(constants.uiNames.FeedbackUI, {
			renderMethod: (instance) => {
				return <FeedbackUI id={instance.id} key={instance.id} parameters={instance.parameters}></FeedbackUI>
			}
		});

		uiManager.registerUI(constants.uiNames.AlertUI, {
			renderMethod: (instance) => {
				return <AlertUI id={instance.id} key={instance.id} parameters={instance.parameters}></AlertUI>
			}
		});

		uiManager.registerUI(constants.uiNames.OverlayImgUI, {
			renderMethod: (instance) => {
				return <OverlayImg id={instance.id} key={instance.id} parameters={instance.parameters}></OverlayImg>
			}
		}, constants.uiTags.Hud);

		uiManager.registerUI(constants.uiNames.SkipContentUI, {
			renderMethod: (instance) => {
				return (null)
				// return <SkipContentUI id={instance.id} key={instance.id} parameters={instance.parameters}></SkipContentUI>
			}
		});

		uiManager.registerUI(constants.uiNames.AiChatUI, {
			renderMethod: (instance) => {
				return <AiChatUI id={instance.id} key={instance.id} parameters={instance.parameters}></AiChatUI>
			}
		});

		uiManager.registerUI(constants.uiNames.IntroScreenUI, {
			renderMethod: (instance) => {
				return <IntroScreenUI id={instance.id} key={instance.id} parameters={instance.parameters}></IntroScreenUI>
			}
		});

		uiManager.registerUI(constants.uiNames.ScenarioInfoUI, {
			renderMethod: (instance) => {
				return <ScenarioInfoUI id={instance.id} key={instance.id} parameters={instance.parameters}></ScenarioInfoUI>
			}
		});


	}, [state]);

	return state.gameManager && state.gameManager.environment && state.gameManager.environment.isReady ? (
		<div className={`in-game-overlay-container in-game-ui-container ui-container-root modal-disable-select`}>
			{/* {props.gameManager.UiManager.render()} */}
			{props.gameManager.SoundManager.render()}
			{props.hideAllUIs ? (
				<div>

				</div>
			) : (
				<div>

					<div style={{ position: 'absolute', top: '0', left: '0' }} id='main-content-top' tabIndex={0} aria-label='Start of Content'></div>
					<SingleUI id={constants.uiNames.HUDUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.OverlayImgUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.QuestionType1UI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.IntroScreenUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.ScenarioInfoUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.FeedbackUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<InternalMentorComp></InternalMentorComp>
					<SingleUI id={constants.uiNames.SkipContentUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.ReturnToMainMenuUI} uiManager={props.gameManager.UiManager}></SingleUI>
					<SingleUI id={constants.uiNames.AlertUI} uiManager={props.gameManager.UiManager}></SingleUI>
					

					{(props.gameManager.UiManager as JsxUIManager).renderSingleGeneralUIs()}
					<div id={'main-content-bottom'} tabIndex={0} style={{ position: 'absolute', top: '0', left: '0' }}></div>
					<SingleUI id={constants.uiNames.AiChatUI} uiManager={props.gameManager.UiManager}></SingleUI>

				</div>
			)}

			<InternalCaptionComp></InternalCaptionComp>
		</div>
	) : (null);
};

export default UIOverlay;

const InternalCaptionComp = () => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const [isExpanded, setIsExpanded] = useState(true);

	(window as any)['cc-inited'] = () => {
		setForceUpdate(!forceUpdate);
	}

	(window as any).forceUpdateInternalCCComp = () => {
		Tools.getSaveData(true).then((data: CustomGameDataManager) => {
			savedData = data;
			setForceUpdate(!forceUpdate);
		});
	}

	if(!savedData) {
		return null;
	}

	(window as any).CCEnabled = savedData.data.isClosedCaptionEnabled;
	

	if (typeof (window as any).CCEnabled === 'undefined') {
		(window as any).CCEnabled = true;
	}
	return ccManager ? (
		<div>
			{<ReactCaption
				currentCaption={ccManager.currentCaption}
				isPaused={ccManager.isPaused}
			></ReactCaption>}
			{ccManager && ccManager.currentCaption && !ccManager.isPaused && <div className="caption-container">
				{(window as any).CCEnabled &&
					<div className="caption-block" style={{
						'left': isExpanded ? '0' : '-100%',
						'bottom': '28px',
						pointerEvents: 'all',
						transform: 'unset'
					}}>
						<p className="caption-paragraph" dangerouslySetInnerHTML={{ __html: parseDynamicHtml(ccManager.currentCaption) }}>
						</p>
						<div className='collapse-bttn' style={{
							'left': isExpanded ? '0' : '100%',
							pointerEvents: 'all',
							cursor: 'pointer',
							transform: 'unset'
						}}tabIndex={0} aria-label='Toggle Captions' onKeyUp={Tools.mapDivEnterToClick} onClick={() => {
							setIsExpanded(!isExpanded);
						}}>
							<img className="cc-img center-element make-white" src={ isExpanded ? (process.env.PUBLIC_URL + '/assets/images/closed-captioning-on.svg') : (process.env.PUBLIC_URL + '/assets/images/closed-captioning-off.svg')} />
						</div>
					</div>
				}
			</div>
			}

		</div>
	) : (null);

};

const InternalMentorComp = () => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const container = useRef();
	// const [isExpanded, setIsExpanded] = useState(true);

	

	// (window as any).forceUpdateInternalCCComp = () => {
	// 	Tools.getSaveData(true).then((data: CustomGameDataManager) => {
	// 		savedData = data;
	// 		setForceUpdate(!forceUpdate);
	// 	});
	// }

	// if(!savedData) {
	// 	return null;
	// }

	// (window as any).CCEnabled = savedData.data.isClosedCaptionEnabled;
	

	// if (typeof (window as any).CCEnabled === 'undefined') {
	// 	(window as any).CCEnabled = true;
	// }
	return (
		<div>
			<div id='internal-mentor-comp' style={{
				position: 'absolute',
				left: '430px',
				width: '200px',
				height: '200px',
				pointerEvents: 'none'
			}}>
				<MentorUI onUpdate={() => {
					const parent = document.getElementById('internal-mentor-comp');

					parent.style.top = (window as any)['mentor-internal-override-top'] ?? '231px'
					parent.style.visibility = (window as any)['mentor-internal-is-visible'] ? 'visible' : 'hidden'
				}} mediaId={Tools.generateGuid()} autoPlay={true} onDone={() => {
					if((window as any)['mentor-internal-onDone']) {
						(window as any)['mentor-internal-onDone']();
					}
				}}></MentorUI>
			</div>
		</div>
	);

};